// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Calendar.css */
.calendar-page {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  margin: auto;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  background-color: white;
  height: 100vh;
  align-content: center;
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5em;
  font-size: 24px;
  background-color: #f7f7f7;
}

.year-selector,
.month-selector,
.today-button,
.footer-button {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 0.5em 1em;
  cursor: pointer;
}

.calendar-grid {
  width: 100%;
  background-color: #f7f7f7;
  border-collapse: collapse;
}

.calendar-grid th {
  background-color: #f7f7f7;
}

.calendar-grid td,
.calendar-grid th {
  text-align: center;
  border: 1px solid #ddd;
  padding: 0.5em;
  height: 40px;
  vertical-align: middle;
}

.calendar-cell.empty {
  background-color: #f9f9f9;
}

.calendar-cell.current-day {
  background-color: #ff3b30;
  color: white;
  border-radius: 50%;
}

.calendar-footer {
  display: flex;
  justify-content: space-between;
  padding: 0.5em;
  background-color: #f7f7f7;
}

.footer-button {
  flex-grow: 1;
  text-align: center;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/css/Calander.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,uGAAuG;EACvG,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;;;EAIE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":["/* Calendar.css */\n.calendar-page {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  margin: auto;\n  box-shadow: 0 0 10px rgba(0,0,0,0.1);\n  background-color: white;\n  height: 100vh;\n  align-content: center;\n}\n\n.calendar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5em;\n  font-size: 24px;\n  background-color: #f7f7f7;\n}\n\n.year-selector,\n.month-selector,\n.today-button,\n.footer-button {\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 0.5em 1em;\n  cursor: pointer;\n}\n\n.calendar-grid {\n  width: 100%;\n  background-color: #f7f7f7;\n  border-collapse: collapse;\n}\n\n.calendar-grid th {\n  background-color: #f7f7f7;\n}\n\n.calendar-grid td,\n.calendar-grid th {\n  text-align: center;\n  border: 1px solid #ddd;\n  padding: 0.5em;\n  height: 40px;\n  vertical-align: middle;\n}\n\n.calendar-cell.empty {\n  background-color: #f9f9f9;\n}\n\n.calendar-cell.current-day {\n  background-color: #ff3b30;\n  color: white;\n  border-radius: 50%;\n}\n\n.calendar-footer {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.5em;\n  background-color: #f7f7f7;\n}\n\n.footer-button {\n  flex-grow: 1;\n  text-align: center;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
